import { render, staticRenderFns } from "./balanceOfTrade.vue?vue&type=template&id=26aa32da&"
import script from "./balanceOfTrade.vue?vue&type=script&lang=ts&"
export * from "./balanceOfTrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports